var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHongKong(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "512px",
    viewBox: "-8 0 464 464",
    width: "512px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m440.800781 144-8-88h-8l-7.199219-48.800781c-.800781-4-4-7.199219-8-7.199219h-17.601562v24h-16v-24h-18.398438c-4 0-7.203124 3.199219-8 7.199219l-6.402343 48.800781h-8l-8 88h-7.199219v320h128v-320zm-16.800781 8v24h-16v-24zm-32-40v-40h16v40zm-32-72h48v16h-48zm0 32h16v40h-16zm32 80v24h-16v-24zm-48 0h16v24h-16zm88 248h-96v-16h96zm-88-32v-24h16v24zm32 0v-24h16v24zm32 0v-24h16v24zm24-64h-96v-16h96zm-88-32v-24h16v24zm32 0v-24h16v24zm32 0v-24h16v24zm24-64h-96v-16h96zm0 0",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176 187.199219v73.601562l36.800781-36.800781zm0 0",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176 404.800781 40 40v-81.601562l-40 40zm0 0",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176 284.800781 40 40v-81.601562l-40 40zm0 0",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176 464h36.800781l-36.800781-36.800781zm0 0",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176 307.199219v73.601562l36.800781-36.800781zm0 0",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m232 324.800781 40-40v-1.601562l-40-40zm0 0",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272 464v-36.800781l-36.800781 36.800781zm0 0",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272 380.800781v-73.601562l-36.800781 36.800781zm0 0",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.199219 224 36.800781 36.800781v-73.601562zm0 0",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m232 444.800781 40-40v-1.601562l-40-40zm0 0",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208 112h32v27.199219l-8-8v73.601562l36.800781-36.800781-12.800781-12.800781v-91.199219h-16v32h-32v-32h-16v91.199219l-12.800781 12.800781 36.800781 36.800781v-73.601562l-8 8zm0 0",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56 44 8-4 8 4v44h-16zm0 60h16v16h-16zm-4.800781 32h25.601562l24 24h-73.601562zm60.800781 40v16h-16v-16zm-32 0v16h-32v-16zm-64 0h16v16h-16zm56 288v-184h-16v184h-24v-200h24v-24h16v24h24v200zm40 0v-216h-24v-24h-48v24h-24v216h-16v-256h128v256zm0 0",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHongKong);
export default __webpack_public_path__ + "static/media/hong-kong.18a25dcc.svg";
export { ForwardRef as ReactComponent };